
import { Component, Vue, Watch } from 'vue-property-decorator';

import CPLoader from '@/components/globals/CPLoader.vue';
import CPFetchingOverlay from '@/components/globals/CPFetchingOverlay.vue';
import CPRadioGroup from '@/components/open-account/input/CPRadioGroup.vue';

@Component({
  components: {
    CPFetchingOverlay,
    CPLoader,
    CPRadioGroup,
  },
})
export default class CPWatchlistEdit extends Vue {

  public gainRate: any | null = null;
  public fallRate: any | null = null;
  public loading: boolean = false;

  public get editWatchlist() {
    return this.$store.state.watchlist.editWatchlist;
  }

  public close() {
    this.$store.commit('setEditWatchlist', null);
  }

  public async updateWatchlist() {
    this.loading = true;

    const updatedWatchlist: any = {
      GainRate: this.gainRate,
      FallRate: parseFloat(this.fallRate),
      ShoppingBasketId: this.editWatchlist.ShoppingBasketId,
    };

    await this.$store.dispatch('updateWatchlist', updatedWatchlist);
    this.loading = false;
  }

  @Watch('editWatchlist')
  public updateVals() {
    this.gainRate = this.editWatchlist.GainRate;
    this.fallRate = parseFloat(this.editWatchlist.FallRate);
  }

  public mounted() {
    this.updateVals();
  }

}
